export const subMenuConstants = {
  SUBMENU_REQUEST: 'SUBMENU_REQUEST',
  SUBMENU_SUCCESS: 'SUBMENU_SUCCESS',
  SUBMENU_FAILURE: 'SUBMENU_FAILURE',
  SUBMENU_SUCCESS_BY_SOCKET: 'SUBMENU_SUCCESS_BY_SOCKET',
};
